<div :class="content_class">
  <div class="portfolio-chart">
      <div class="superset-embedded-container m-0 p-0">

        <!-- Superset Chart -->
        <div :id="chart_id"></div>

        <!-- Loading State -->
        <div v-if="iframe_loading && !iframe_error" class="iframe-loading">
          <div class="spinner-border spinner-border-sm me-2" role="status"></div>
          Loading embedded dashboard...
        </div>

        <div v-if="iframe_error" class="iframe-error dashboard-embed-error">
          <h5 class="fw-bold mb-2">Dashboard could not be loaded</h5>
          <p class="mb-0">
            The embedded dashboard request failed. Check the Superset dashboard ID, embed permissions, and service worker URL.
          </p>
        </div>

      </div>
    </div>
</div>
